import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/base/Breadcrumb';

const jsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      name: 'JM漫画导航 - jmcomic-zzz.one',
      url: 'https://jmcomic-zzz.one',
      description: 'JM漫画官方入口导航平台，提供最新访问地址、镜像站列表、内容分类导航及常见问题解答，帮助用户快速稳定地连接到JM漫画平台。',
      contactPoint: {
        '@type': 'ContactPoint',
        contactType: 'customer service',
        email: 'support@jmcomic-zzz.one',
        availableLanguage: ['Chinese'],
      },
    },
    {
      '@type': 'WebPage',
      name: '关于我们 - jmcomic-zzz.one',
      url: 'https://jmcomic-zzz.one/about',
      isPartOf: { '@id': 'https://jmcomic-zzz.one/#website' },
    },
    {
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: '首页',
          item: 'https://jmcomic-zzz.one/',
        },
        {
          '@type': 'ListItem',
          position: 2,
          name: '关于我们',
        },
      ],
    },
  ],
};

const testimonials = [
  {
    name: '漫画迷小王',
    text: '这个导航站太方便了！之前经常找不到JM漫画的最新地址，有了jmcomic-zzz.one之后再也不用担心了，地址更新及时，一键直达。',
    date: '2026年7月',
  },
  {
    name: '资深漫友阿杰',
    text: '分类很清晰，不管是找最新地址还是看使用指南都很便捷。强烈推荐给所有JM漫画的用户收藏！',
    date: '2026年6月',
  },
  {
    name: '二次元爱好者小李',
    text: '界面简洁美观，访问速度快。FAQ板块解决了我很多疑问，不用再去到处搜索了。给站长点赞！',
    date: '2026年8月',
  },
  {
    name: '漫画新手小陈',
    text: '作为刚接触JM漫画的新人，这个导航站帮我快速上手。访问指南写得很详细，分类浏览功能也很好用。',
    date: '2026年7月',
  },
];

export default function About() {
  return (
    <>
      <ScrollToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <Navbar />

      <main>
        <section className="pt-24 pb-8 md:pt-28 md:pb-10 bg-background-100">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                { label: '关于我们' },
              ]}
            />
            <h1 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mt-4 mb-2">
              关于我们
            </h1>
            <p className="text-foreground-600 text-sm">
              了解jmcomic-zzz.one的使命与愿景
            </p>
          </div>
        </section>

        <section className="py-10 md:py-14 bg-background-50">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center">
              <div>
                <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950 mb-4">
                  品牌介绍
                </h2>
                <div className="space-y-3 text-foreground-700 text-sm leading-relaxed">
                  <p>
                    <strong className="text-foreground-900">jmcomic-zzz.one</strong> 是JM漫画资源的官方入口导航平台。我们的使命是为广大漫画爱好者提供一个稳定、可靠、高效的导航服务，帮助用户快速找到JM漫画的最新访问地址和使用方法。
                  </p>
                  <p>
                    随着网络环境的变化，漫画平台的访问地址可能会频繁更新。我们深知用户在寻找可用地址时遇到的困扰——反复尝试失效链接、浪费时间搜索、担心访问到钓鱼网站等。因此，我们建立了这个导航平台，持续追踪并验证JM漫画的最新可用域名与镜像站点。
                  </p>
                  <p>
                    除了提供最新地址外，我们还整理了详细的访问指南、热门作品推荐、分类浏览和常见问题解答，致力于成为JM漫画用户的一站式服务平台。
                  </p>
                  <p>
                    我们的核心价值是<strong className="text-foreground-900">准确、及时、安全</strong>。每一组地址信息都经过人工验证，确保用户通过本平台访问的都是真实有效的JM漫画入口。
                  </p>
                </div>
              </div>
              <div className="relative rounded-lg overflow-hidden h-64 md:h-80">
                <img
                  src="https://readdy.ai/api/search-image?query=Japanese%20manga%20reading%20atmosphere%2C%20warm%20cozy%20room%20with%20bookshelves%20filled%20with%20comic%20books%2C%20soft%20warm%20lighting%2C%20artistic%20illustration%20style%2C%20relaxing%20vibe%2C%20minimalist%20composition&width=800&height=600&seq=about-brand&orientation=portrait"
                  alt="JM漫画导航品牌形象"
                  title="JM漫画导航品牌形象"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </section>

        <section className="py-10 md:py-14 bg-background-100">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950 mb-2 text-center">
              用户口碑
            </h2>
            <p className="text-foreground-600 text-sm text-center mb-8 md:mb-10">
              来自真实用户的评价与反馈
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6">
              {testimonials.map((t, idx) => (
                <div
                  key={idx}
                  className="bg-background-50 rounded-lg border border-background-200/70 p-5"
                >
                  <div className="flex items-center gap-1.5 mb-3">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <i key={star} className="ri-star-fill text-accent-500 text-sm"></i>
                    ))}
                  </div>
                  <p className="text-foreground-700 text-sm leading-relaxed mb-4">
                    "{t.text}"
                  </p>
                  <div className="flex items-center justify-between">
                    <span className="font-medium text-foreground-900 text-sm">
                      {t.name}
                    </span>
                    <span className="text-foreground-400 text-xs">
                      {t.date}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-10 md:py-14 bg-background-50">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950 mb-2 text-center">
              联系我们
            </h2>
            <p className="text-foreground-600 text-sm text-center mb-8 md:mb-10">
              如您有任何问题、建议或合作意向，欢迎通过以下方式联系我们
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6">
              <div className="flex flex-col items-center text-center p-6 bg-background-100 rounded-lg border border-background-200/70">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-3">
                  <i className="ri-mail-line text-xl"></i>
                </div>
                <h3 className="font-heading font-semibold text-foreground-950 text-sm mb-1.5">
                  电子邮箱
                </h3>
                <p className="text-foreground-600 text-xs">
                  support@jmcomic-zzz.one
                </p>
              </div>
              <div className="flex flex-col items-center text-center p-6 bg-background-100 rounded-lg border border-background-200/70">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-3">
                  <i className="ri-discord-line text-xl"></i>
                </div>
                <h3 className="font-heading font-semibold text-foreground-950 text-sm mb-1.5">
                  社交媒体
                </h3>
                <p className="text-foreground-600 text-xs">
                  关注我们的社交媒体账号获取最新动态
                </p>
              </div>
              <div className="flex flex-col items-center text-center p-6 bg-background-100 rounded-lg border border-background-200/70">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 mb-3">
                  <i className="ri-question-answer-line text-xl"></i>
                </div>
                <h3 className="font-heading font-semibold text-foreground-950 text-sm mb-1.5">
                  在线反馈
                </h3>
                <p className="text-foreground-600 text-xs">
                  通过JM漫画平台内提交反馈建议
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="py-10 md:py-14 bg-background-100">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950 mb-6 text-center">
              免责声明
            </h2>
            <div className="bg-background-50 rounded-lg border border-background-200/70 p-5 md:p-6">
              <div className="space-y-3 text-foreground-600 text-sm leading-relaxed">
                <p>
                  jmcomic-zzz.one 是一个独立的导航服务平台，旨在帮助用户更方便地访问JM漫画平台。我们不是JM漫画的官方运营方，也不代表JM漫画平台。
                </p>
                <p>
                  本网站提供的所有地址和信息仅供参考，我们不保证所有地址在任何时间和地点都可访问。网络访问可能受多种因素影响，包括地理位置、网络环境和第三方政策等。
                </p>
                <p>
                  所有漫画内容的版权归原作者及JM漫画平台所有。我们尊重知识产权，如果您认为本网站上的内容侵犯了您的权益，请通过联系方式与我们沟通。
                </p>
                <p>
                  用户使用本网站导航到第三方平台后，应遵守该平台的使用条款和规定。对于用户在第三方平台上的行为及其产生的后果，本网站不承担任何责任。
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}